import {
  ActionIcon,
  Box,
  Button,
  Card,
  Group,
  rem,
  SimpleGrid,
  Space,
  Stack,
  Text,
  Textarea,
  TextInput
} from "@mantine/core"
import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandTwitter,
  IconBrandWhatsapp,
  IconBuilding,
  IconBuildingSkyscraper,
  IconMail,
  IconPhone
} from "@tabler/icons-react"
import { useNavigate } from "react-router-dom"
import { footer, mainHeader, multiLineEntryWithIcon } from "../Common/Renders"

export function Contact(): React.ReactElement {
  const navigate = useNavigate()

  return (
    <Box p={"md"}>
      {mainHeader()}

      <Space h={rem(32)} />

      <Stack gap={rem(16)}>
        <Text size={rem(18)} opacity={0.85}>
          {
            "For any inquiries, feedback, or support, please reach out to us through the contact details provided below. We look forward to hearing from you!"
          }
        </Text>
      </Stack>

      <Space h={rem(32)} />

      <Card withBorder radius={rem(16)} p={"md"}>
        <Stack my={rem(16)} gap={rem(16)}>
          {multiLineEntryWithIcon(
            "Head Office",
            "#74, Jamalapur, Jaunpur, 222137, Uttar Pradesh, India",
            IconBuildingSkyscraper
          )}
          {multiLineEntryWithIcon(
            "Registered Office",
            "#74, Jamalapur, Jaunpur, 222137, Uttar Pradesh, India",
            IconBuilding
          )}
          {multiLineEntryWithIcon("Phone", "+91 - 9794092111", IconPhone)}
          {multiLineEntryWithIcon("Email", "contact@dharohargroup.com", IconMail)}
        </Stack>

        <Card.Section p="md" withBorder inheritPadding>
          <Group gap={rem(8)} align="center" justify="end">
            <ActionIcon
              size={"md"}
              variant="subtle"
              onClick={() => window.open("https://www.facebook.com/people/Dharohar-Group/100094024392867/")}
            >
              <IconBrandFacebook
                size={"24px"}
                color="#1877F2" // Facebook blue color
              />
            </ActionIcon>
            <ActionIcon
              size={"md"}
              variant="subtle"
              onClick={() => window.open("https://api.whatsapp.com/send?phone=9794092111")}
            >
              <IconBrandWhatsapp
                size={"24px"}
                color="#25D366" // WhatsApp green color
              />
            </ActionIcon>
            <ActionIcon
              size={"md"}
              variant="subtle"
              onClick={() => window.open("https://www.instagram.com/mydharohargroup")}
            >
              <IconBrandInstagram
                size={"24px"}
                color="#E1306C" // Instagram pink color
              />
            </ActionIcon>
            <ActionIcon size={"md"} variant="subtle" onClick={() => navigate("/")}>
              <IconBrandLinkedin
                size={"24px"}
                color="#0077B5" // LinkedIn blue color
              />
            </ActionIcon>
            <ActionIcon size={"md"} variant="subtle" onClick={() => navigate("/")}>
              <IconBrandTwitter
                size={"24px"}
                color="#1DA1F2" // Twitter blue color
              />
            </ActionIcon>
          </Group>
        </Card.Section>
      </Card>

      <Space h={rem(32)} />

      <iframe
        style={{ border: 0, borderRadius: rem(16) }}
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d246.92165718332205!2d82.58577323930466!3d25.541570926368195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399021bf3daa80d1%3A0xd8de6359ec4fa18a!2sDharohar%20Group!5e0!3m2!1sen!2sin!4v1749300447397!5m2!1sen!2sin"
        width="100%"
        height="480px"
        loading="lazy"
      ></iframe>

      <Space h={rem(32)} />

      <Text size={rem(18)} opacity={0.85}>
        {"Alternatively, you can fill out our contact form below. We will get back to you as soon as possible."}
      </Text>

      <Card withBorder radius={rem(16)} p={"md"} mt={rem(32)}>
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing={rem(16)} my={rem(16)}>
          <TextInput placeholder="Your Name" label="Name" withAsterisk />
          <TextInput placeholder="Your Phone" label="Phone" withAsterisk />
          <TextInput placeholder="Your Email" label="Email" />
        </SimpleGrid>

        <Textarea placeholder="Your Message" label="Message" autosize minRows={4} withAsterisk />

        <Space h={rem(32)} />

        <Stack align="end">
          <Button maw={rem(240)}> Send Message</Button>
        </Stack>
      </Card>

      <Space h={rem(48)} />

      {footer()}
    </Box>
  )
}
